/**
 * Возвращает имя файла с тем же расширением, что у originalFileName:
 * пользователь может менять только «stem»; всё после последней точки в вводе отбрасывается.
 */
export function preserveFileExtension(originalFileName: string, edited: string): string {
  const orig = originalFileName.trim();
  const editedTrim = edited.trim();
  if (!editedTrim) {
    return orig;
  }

  const origDot = orig.lastIndexOf('.');
  const hasOrigExt = origDot > 0 && origDot < orig.length - 1;
  const origExt = hasOrigExt ? orig.substring(origDot) : '';

  if (!origExt) {
    return editedTrim;
  }

  let stem = editedTrim;
  const edDot = stem.lastIndexOf('.');
  if (edDot >= 0) {
    stem = stem.substring(0, edDot);
  }
  stem = stem.replace(/\.+$/, '').trim();
  if (!stem) {
    const origStem = orig.substring(0, origDot).trim();
    stem = origStem || 'file';
  }
  return stem + origExt;
}
